import { FormatSize } from '@mui/icons-material'
import { ClickAwayListener } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFontSizeTier } from '../../useFontSizeTier'
import { useLogger } from '../../useLogger'
import { useVideoScale } from '../../useVideoScale'
import { PlayerButton } from '../PlayerButton'
import { MenuItem } from './MenuItem'

const Options = [
  { tier: 'small', labelKey: 'font_size_small' },
  { tier: 'medium', labelKey: 'font_size_medium' },
  { tier: 'large', labelKey: 'font_size_large' },
] as const

export const FontSize = () => {
  const { videoScale } = useVideoScale()
  const { sizeTier, updateSizeTier } = useFontSizeTier()
  const { clickFontSizeButton, changeFontSize } = useLogger()
  const [showMenu, setShowMenu] = useState(false)
  const { t } = useTranslation()

  return (
    <ClickAwayListener onClickAway={() => setShowMenu(false)}>
      <div style={{ position: 'relative' }}>
        <PlayerButton
          onClick={() => {
            setShowMenu(!showMenu)
            clickFontSizeButton()
          }}
        >
          <FormatSize
            sx={{
              width: videoScale * 52,
              height: videoScale * 52,
              color: '#fff',
              filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.5))',
            }}
          />
          {videoScale > 0.4 && (
            <span
              style={{
                fontSize: `${videoScale * 24}px`,
                fontWeight: 'bold',
                marginLeft: '8px',
              }}
            >
              {t('font_size_setting')}
            </span>
          )}
        </PlayerButton>
        {showMenu && (
          <div
            style={{
              minWidth: '120px',
              position: 'absolute',
              bottom: `${videoScale * 104}px`,
              left: 0,
              backgroundColor: '#EBECED',
              color: 'black',
              borderRadius: '8px',
              padding: '8px 0',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {Options.map(({ tier, labelKey }) => (
              <MenuItem
                key={tier}
                onClick={() => {
                  updateSizeTier(tier)
                  changeFontSize(tier)
                  setShowMenu(false)
                }}
                active={sizeTier === tier}
                text={t(labelKey)}
              />
            ))}
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}
